module.exports = "/images/nuclear@3x.png?48a33b31b718da74d65c472ada8c1496";